<template>
  <section class="py-20 bg-gradient-to-br from-green-400 to-green-500 text-white">
    <div class="container mx-auto px-4">
      <!-- Heading -->
      <div class="text-center mb-14">
        <h2 class="text-4xl font-bold uppercase tracking-wide relative inline-block after:absolute after:bottom-[-10px] after:left-1/2 after:transform after:-translate-x-1/2 after:w-24 after:h-1 after:bg-yellow-400">
          Our Sectors
        </h2>
        <p class="mt-4 text-lg text-white/90">Explore our top industry partnerships</p>
      </div>

      <!-- Sector Cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div
          v-for="sector in sectors"
          :key="sector.slug"
          class="bg-white text-gray-800 rounded-3xl shadow-lg overflow-hidden cursor-pointer transform transition duration-300 hover:scale-[1.03] group focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2"
        >
          <!-- Image -->
          <img 
            :src="sector.image" 
            :alt="sector.name" 
            class="w-full h-48 object-cover group-hover:brightness-110 transition duration-300"
            loading="lazy"
            width="400"
            height="192"
          />

          <!-- Content -->
          <div class="p-6">
            <h3 class="text-xl font-bold mb-2 group-hover:text-sky-600 transition">{{ sector.name }}</h3>
            <p class="text-gray-600 mb-4">{{ sector.description }}</p>
            <router-link
              :to="`/PDetails/${sector.slug}`"
              class="inline-block bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-6 py-2 
              rounded-full transition-all duration-300 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 
              focus:ring-green-600 focus:ring-offset-2"
              aria-label="Read More"
            >
              Read More
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const sectors = [
  {
    name: 'Healthcare',
    slug: 1,
    description: 'Innovative HVAC solutions for healing environments, ensuring patient comfort and air purity.',
    image: 'https://futurehealthcaretoday.com/wp-content/uploads/2023/01/shutterstock_1101930905-scaled.jpg',
  },
  {
    name: 'Industry',
    slug: 2,
    description: 'Energy-efficient climate control for manufacturing plants and industrial facilities.',
    image: 'https://cdn.corporatefinanceinstitute.com/assets/Industry-1024x576.jpeg',
  },
  {
    name: 'Hotels & Resorts',
    slug: 3,
    description: 'Premium comfort for guests with smart, quiet and eco-friendly HVAC systems.',
    image: 'https://imageio.forbes.com/specials-images/imageserve/6426e73a094eb28ac98cd6f1//960x0.jpg?height=473&width=711&fit=bounds',
  },
  {
    name: 'Aerospace & Transport',
    slug: 4,
    description: 'Advanced climate engineering for planes, trains and future mobility.',
    image: 'https://cdn.pixabay.com/photo/2019/12/27/04/29/jet-engine-4721671_1280.jpg',
  },
  // {
  //   name: 'Data Centers',
  //   slug: 5,
  //   description: 'Precise temperature and humidity control to protect critical IT infrastructure.',
  //   image: 'https://cdn.pixabay.com/photo/2017/07/06/03/01/data-center-2476790_1280.jpg',
  // },

];

</script>